"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = exports.GridWrap = exports.MotionFade = exports.Fade = exports.MotionParallax = exports.CenterStack = exports.CenterButton = void 0;
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const framer_motion_1 = require("framer-motion");
const Parallax = app_1.styled.div `
  height: 100%;
`;
exports.CenterButton = (0, app_1.styled)(ui_1.Button) `
  display: block;
  margin: 0 auto;
  @media ${app_1.mobile} {
    margin-top: 3rem;
  }
`;
exports.CenterStack = (0, app_1.styled)(ui_1.Stack) `
  align-items: center;
`;
exports.MotionParallax = (0, framer_motion_1.motion)(Parallax);
exports.Fade = app_1.styled.div `
  height: 100%;
  max-width: 25rem;
  position: relative;
`;
exports.MotionFade = (0, framer_motion_1.motion)(exports.Fade);
exports.GridWrap = (0, app_1.styled)(ui_1.Grid) `
  grid-auto-rows: 7rem;

  @media ${app_1.notDesktop} {
    grid-template-columns: 1fr;
    grid-auto-rows: 26rem;
    grid-gap: ${(theme) => theme.spacing.extraLarge};
  }
`;
exports.Item = (0, app_1.styled)(ui_1.GridItem) `
  grid-row: ${(_, { $row }) => `${$row} / span 4`};
  @media ${app_1.notDesktop} {
    grid-column: 1;
    grid-row: span 1;
  }
`;
